<template>
  <div class="services">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />

    <!-- 页面 Banner -->
    <section class="page-banner">
      <div class="container">
        <h1>服务支持</h1>
        <p>专业团队全程保障，让您的业务运行无忧</p>
      </div>
    </section>

    <!-- 页面内容 -->
    <section class="services-content">
      <div class="container">
        <div class="services-grid">
          <div
            class="service-card"
            v-for="service in services"
            :key="service.id"
          >
            <div class="service-image">
              <img :src="service.img" :alt="service.title" />
            </div>
            <h4>{{ service.title }}</h4>
            <p>{{ service.contentSimple }}</p>
            <router-link
              :to="`/service/serviceDetail?id=${service.id}`"
              class="btn"
              >查看详情</router-link
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import api from "@/api";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "Services",
  components: {
    Navbar,
    Footer,
  },
  mixins: [pageDataMixin],
  data() {
    return {
      services: [],
    };
  },
  mounted() {
    this.fetchServices();
  },
  methods: {
    fetchServices() {
      api
        .get("/api/service/getServiceList")
        .then((response) => {
          if (response.data.code === 0) {
            this.services = response.data.data;
          }
        })
        .catch(() => {
          // 静默处理错误
        });
    },
  },
};
</script>

<style scoped>
.services {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* ========= Banner ========= */
.page-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4rem 0;
  text-align: center;
}
.page-banner h1 {
  font-size: 2.5rem;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}
.page-banner p {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

/* 服务内容 */
.services-content {
  padding: 3rem 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.service-card {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-image {
  margin-bottom: 1rem;
}

.service-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
}

.service-card h4 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.service-card p {
  margin-bottom: 1.5rem;
  line-height: 1.6;
  flex-grow: 1;
}

.btn {
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 0.8rem 1.5rem;
  text-decoration: none;
  border-radius: 50px;
  transition: background-color 0.3s ease;
  width: auto;
  white-space: nowrap;
  text-align: center;
}

.btn:hover {
  background-color: #0069d9;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
